const COUNT_THRESHOLD = 1000;

/**
 * Makes sure rating count doesn't exceed the maximum count threshold
 * @param  {Integer} {count} Number of ratings a gig has recieved
 * @return {String || Integer} the rating count or 1k+ if it exceeds the threshold
 */

export const getRatingsCount = (count) => {
    if (count >= COUNT_THRESHOLD) {
        return '1k+';
    }

    return count;
};



// WEBPACK FOOTER //
// ./src/utils/getRatingsCount/index.js